export default "__VITE_ASSET__BrU8r0sq__"